module.exports = __webpack_public_path__ + "2ec613842ef6ca3c94b9ae52ce9377a5.pdf";